import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalSize } from "components/notifications";
import { FormCheckbox } from "components/form-fields";

const defaultFunction = () => { };

// Display preferences for the Earned Recognition KPI grids. Each setting applies as soon as it is
// changed, so the modal has no save step.
export function ErSettingsModal(
    {
        isOpen = false,
        onClose = defaultFunction,
        newestPeriodFirst = false,
        onPeriodOrderChange = defaultFunction
    }
) {
    function handlePeriodOrderChange(event) {
        onPeriodOrderChange(event.target.checked);
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Settings"
            size={ModalSize.SMALL}
            clickOutsideClose={true}
        >
            <FormCheckbox
                id="er-settings-newest-period-first"
                checked={newestPeriodFirst}
                label="Show the newest period first"
                onChange={handlePeriodOrderChange}
            />
        </Modal>
    );
}

ErSettingsModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    newestPeriodFirst: PropTypes.bool,
    onPeriodOrderChange: PropTypes.func
};
